// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2rVfZ","vLegacy":"SelectSecondary_vLegacy__25cAN","error":"SelectSecondary_error__1m-40","disabled":"SelectSecondary_disabled__lZwHb"};